const data = {
  translation: {
    lbl_welcome: "Chào mừng bạn tới",
    lbl_hodo_community_events: "Sự kiện cộng đồng HODO",
    lbl_setup_sound_and_video:
      "Thiết lập thiết bị âm thanh và hình ảnh trước khi tham gia",
    lbl_join_room: "Tham gia phòng",
    lbl_join_studio: "Tham gia studio",
    lbl_join_conference: "Tham gia hội thảo",
    lbl_enter_name: "Nhập tên của bạn",
    lbl_on: "Bật",
    lbl_off: "Tắt",
    lbl_change_camera: "Chuyển đổi Camera trước hoặc sau",
    lbl_add_virtual_background: "Thêm hình nền ảo",
    lbl_vietnamese: "Tiếng Việt",
    lbl_english: "Tiếng Anh",
    lbl_french: "Tiếng Pháp",
    gender: {
      male: "Nam",
      female: "Nữ",
      unknown: "Không xác định",
    },
    lbl_setting_device: "Cài đặt thiết bị",
    lbl_notification: "Thông báo",
    lbl_view_layout: "Cách trình bày",
    lbl_audio_device: "Thiết bị ấm thanh",
    lbl_speaker: "Loa",
    lbl_test: "Thử nghiệm",
    lbl_noise_suppression: "Lọc nhiễu/ Giảm tiếng ồn",
    lbl_participants: "Người đã tham gia",
    lbl_the_leaver: "Người rời đi",
    lbl_new_message: "Tin nhắn mới",
    lbl_peer_joined: "Có người tham gia",
    lbl_peer_leave: "Có người rời phòng",
    lbl_hand_raiser: "Người giơ tay",
    lbl_error: "Lỗi",
    lbl_active_speaker_mode: "Chế độ người nói hiện tại",
    lbl_active_speaker_sorting: "Sắp xếp theo người nói hiện tại",
    lbl_audio_only_mode: "Chỉ phát âm thanh",
    lbl_mirror_local_video: "Phản chiếu video của bạn",
    lbl_hide_local_video: "Ẩn video của bạn",
    lbl_tiles_in_view: "Số ô hiển thị",
    lbl_arranging_active_speakers: "Sắp xếp loa đang hoạt động",

    lbl_personal_video_mirror: "Phản chiếu video cá nhân",
    lbl_personal_video_hidden: "Ẩn video cá nhân",
    lbl_error_check_role: "Lỗi khi kiểm tra vai trò của người dùng",
    lbl_meting: "Họp",
    lbl_room_code_is_disabled: "Mã phòng bị vô hiệu hóa",
    lbl_room_code_does_not_exist: "Mã phòng không tồn tại",
    lbl_endpoint_is_not_reachable: "Không thể truy cập điểm cuối",
    lbl_room_does_not_exist: "Phòng không tồn tại",
    lbl_accessing_disabled:
      "Truy cập phòng bằng định dạng liên kết này đã bị vô hiệu hóa",
    lbl_error_fetching_token: "Lỗi khi tìm nạp mã thông báo",
    fm_toggle_interpretation: "Chọn nghe thông dịch",
    lbl_other_options: "Lựa chọn khác",
    lbl_setting: "Cài đặt",
    lbl_you: "Bạn",
    lbl_have_a_nice_day: "Chúc một ngày tốt lành",
    msg_you_left: "Bạn đã rời {{type}}",
    lbl_left_by_mistake: "Rời nhầm?",
    btn_rejoin: "Tham gia lại",
    msg_back_to_home: "Quay về trang chủ",
    lbl_join_again: "Bạn muốn tham gia lại",
    lbl_click_here: "Chỉ cần ấn vào đây",
    lbl_stream: "Phát trực tiếp",
    lbl_room: "phòng",
    lbl_rename: "Đổi tên",
    lbl_change_role: "Thay đổi vai trò",
    lbl_change_my_role: "Thay đổi vai trò của tôi",
    lbl_mute_all: "Tắt tiếng tất cả",
    lbl_exit: "Thoát",
    lbl_leave_room: "Rời phòng",
    lbl_leave_studio: "Rời Studio",
    lbl_end_room: "Kết thúc phòng",
    lbl_end_room_for_all: "Kết thúc phòng cho tất cả",
    lbl_disable_future_joins: "Vô hiệu hoá tham gia trong tương lai",
    msg_end_room_warning: "Cảnh báo: Hành động này không thể hoàn tác",
    msg_can_rejoin_later: "Bạn có thể tham gia lại sau",
    lbl_url_embed: "Nhúng URL",
    lbl_cancel: "Huỷ bỏ",
    lbl_change: "Thay đổi",
    lbl_update_embed: "Cập nhật nhúng",
    lbl_stop_embed: "Dừng nhúng",
    lbl_embed_and_share: "Nhúng và chia sẻ",
    lbl_change_multiple_role: "Thay đổi vai trò hàng loạt",
    lbl_select_role: "Chọn vai trò",
    lbl_select_language: "Chọn ngôn ngữ",
    preview: {
      room_protected: "Phòng được bảo mật",
      enter_password: "Nhập mật khẩu",
      submit: "Gửi",
      password_incorrect: "Mật khẩu không đúng",
      get_started: "Bắt đầu",
      setup_audio_before_joining:
        "Cài đặt âm thanh và video trước khi tham gia",
    },
    lbl_select_emoji: "Chọn biểu tượng cảm xúc",
    lbl_reactions_timed_live_viewers:
      "Phản ứng sẽ được đồng bộ cho người xem phát trực tiếp.",
    lbl_learn_more: "Tìm hiểu thêm",
    lbl_invalid_url: "URL không hợp lệ!",
    tooltip_hide_sidebar: "Ẩn thanh bên",
    tooltip_show_sidebar: "Hiện thanh bên",
    lbl_need_help: "Bạn cần giúp đỡ?",
    lbl_browse: "Duyệt",
    lbl_audio_playlist: "Danh sách phát âm thanh",
    lbl_video_playlist: "Danh sách phát video",
    lbl_audio_player: "Trình phát âm thanh",
    lbl_start_streaming: "Bắt đầu phát trực tiếp",
    lbl_hls_starting: "HLS đang bắt đầu",
    lbl_rtmp_starting: "RTMP đang bắt đầu",
    lbl_go_live: "Bắt đầu",
    lbl_link_copied: "Đã sao chép liên kết!",
    lbl_copy_invite_link: "Sao chép liên kết mời",
    lbl_hls_streaming: "Phát trực tiếp HLS",
    lbl_hls_streaming_description:
      "Phát trực tiếp từ trình duyệt sử dụng bất kỳ thiết bị nào với nhiều người chủ và nhắn tin thời gian thực, tất cả trong nền tảng này.",
    lbl_invite_people: "Mời mọi người",
    lbl_start_conversation: "Bắt đầu cuộc trò chuyện",
    lbl_starting_stream: "Đang bắt đầu luồng...",
    lbl_cannot_start_recording_once_stream_starts:
      "Bạn không thể bắt đầu ghi khi luồng đã bắt đầu; bạn sẽ phải dừng luồng để bật ghi.",
    lbl_select_multiple_role: "Chọn nhiều vai trò",
    lbl_become_role: "Thành vai trò:",
    lbl_my_screen: "Màn hình của bạn",
    lbl_signal: "Sóng kém",
    lbl_mute_mic: "Bạn đã bị tắt tiếng",
    lbl_participants_1: "Người tham gia",
    lbl_no_participants: "Không có người tham gia",
    lbl_no_suitable_participants: "Không có người tham gia phù hợp",
    lbl_search_participants: "Nhập thông tin tìm kiếm",
    lbl_all: "Tất cả",
    lbl_change_permissions: "Thay đổi quyền",
    lbl_remove_participants: "Bỏ người tham gia",
    lbl_change_role_of: "Thay đổi vai trò của",
    lbl_become: "thành",
    lbl_submit_request_confirm: "Gửi yêu cầu xác nhận",
    lbl_pin: "Ghim",
    lbl_unpin: "Bỏ ghim",
    lbl_outstanding_position_for_everyone: "Vị trí nổi bật cho mọi người",
    lbl_removed_from_prominent_position: "Xoá khỏi vị trí nổi bật",
    lbl_connected_now: "Bây giờ bạn đã được kết nối",
    lbl_open_chat: "Mở cửa sổ trò chuyện",
    lbl_welcome_joined: "Chào mừng bạn đã tham gia",
    lbl_person_first: "Bạn là người đầu tiên tham gia phòng",
    lbl_sit_down:
      "Vui lòng ngồi lại và thư giãn cho đến khi những người khác tham gia",
    lbl_select_maximum_resolution: "Chọn độ phân giải tối đa",
    lbl_resolution_width: "Chiều rộng",
    lbl_resolution_height: "Chiều cao",
    lbl_currently_streaming: "Hiện đang phát trực tuyến:",
    lbl_low: "Thấp",
    lbl_medium: "Trung bình",
    lbl_high: "Cao",
    lbl_sharing_screen: "Bạn đang chia sẻ màn hình của mình",
    lbl_stop_share: "Dừng chia sẻ màn hình",
    lbl_reload_page: "Tải lại trang",
    lbl_reload: "Tải lại",
    lbl_copy_error_details: "Sao chép lỗi vào clipboard",
    lbl_copy_details: "Sao chép chi tiết",
    lbl_copied: "Đã sao chép",
    lbl_settings: "Cài đặt",
    // Auto-added keys for i18n migration (translated)
    lbl_attention: "Chú ý",
    msg_hls_autoplay:
      'Trình duyệt yêu cầu xác nhận phát luồng HLS. Vui lòng nhấn "Phát luồng" để tiếp tục.',
    btn_play_stream: "Phát luồng",
    lbl_permission_error: "Lỗi quyền",
    msg_autoplay_audio:
      "Trình duyệt yêu cầu xác nhận phát âm thanh. Vui lòng cho phép âm thanh để tiếp tục.",
    btn_allow_audio: "Cho phép âm thanh",
    lbl_request_permission: "Yêu cầu quyền",
    lbl_please_wait: "Vui lòng đợi",
    msg_waiting_relax: "Vui lòng thư giãn trong lúc chờ người khác tham gia.",
    msg_reconnect_trying: "Bạn đã mất kết nối mạng. Đang cố gắng kết nối lại.",
    msg_sharing_screen: "Bạn đang chia sẻ màn hình",
    btn_stop_screen_share: "Dừng chia sẻ màn hình",
    msg_end_recording_warning:
      "Bạn có chắc muốn kết thúc ghi âm? Hành động này không thể hoàn tác.",
    btn_dont_end: "Không kết thúc",
    btn_end_recording: "Kết thúc ghi âm",
    lbl_rtmp_url: "URL RTMP",
    ph_enter_rtmp_url: "Nhập URL RTMP",
    lbl_stream_key: "Khóa luồng",
    ph_enter_stream_key: "Nhập khóa luồng",
    btn_end_stream: "Kết thúc luồng",
    msg_waiting_for_stream: "Đang chờ luồng bắt đầu...",
    btn_vote: "Bỏ phiếu",
    lbl_polls_quiz: "Bình chọn/Trắc nghiệm",
    msg_select_poll_type: "Chọn loại bạn muốn tiếp tục",
    lbl_hide_vote_count: "Ẩn số phiếu",
    lbl_make_results_anonymous: "Ẩn danh kết quả",
    btn_create_poll: "Tạo bình chọn",
    btn_create_quiz: "Tạo trắc nghiệm",
    lbl_previous_polls_quiz: "Bình chọn/Trắc nghiệm trước",
    btn_view: "Xem",
    btn_add_another_question: "Thêm câu hỏi khác",
    btn_launch_quiz: "Bắt đầu trắc nghiệm",
    btn_launch_poll: "Bắt đầu bình chọn",
    ph_enter_your_answer: "Nhập câu trả lời của bạn",
    btn_skip: "Bỏ qua",
    lbl_skipped: "Đã bỏ qua",
    lbl_submitted: "Đã gửi",
    lbl_voted: "Đã bầu",
    btn_submit: "Gửi",
    lbl_track_unmute_request: "Theo dõi yêu cầu bỏ im lặng",
    msg_track_unmute_body:
      "{{name}} đã yêu cầu bạn bật tiếng {{source}} {{type}}.",
    lbl_widgets: "Tiện ích",
    lbl_poll_quiz: "Bình chọn/Trắc nghiệm",
    msg_poll_quiz_subtitle: "Tìm hiểu xem người khác nghĩ gì",
    btn_share_music: "Chia sẻ nhạc",
    btn_stop_sharing_music: "Dừng chia sẻ nhạc",
    msg_play_music_from: "Phát nhạc từ Spotify hoặc tab khác",
    msg_stop_playing_music: "Dừng phát nhạc từ Spotify hoặc tab khác",
    lbl_open_meeting_report: "Mở báo cáo cuộc họp",
    lbl_close_meeting_report: "Đóng báo cáo cuộc họp",
    lbl_device_settings: "Cài đặt thiết bị",
    lbl_notifications: "Thông báo",
    lbl_layout: "Bố cục",
    lbl_select_quality: "Chọn chất lượng",
    lbl_screenshare_audio: "Âm thanh chia sẻ màn hình",
    lbl_screenshare: "Chia sẻ màn hình",
    lbl_activate_presentation_slides: "Bắt đầu trình chiếu",
    lbl_deactivate_presentation_slides: "Kết thúc trình chiếu",
    lbl_playlist_music: "Danh sách phát",
    lbl_whiteboard: "Bảng trắng",
    msg_playlist_is_playing: "Danh sách phát đang chạy",
    msg_music_is_playing: "Nhạc đang phát",
    lbl_switch_camera: "Chuyển đổi camera",
    lbl_share: "Chia sẻ",
    lbl_start_sharing: "Bắt đầu chia sẻ",
    lbl_choose_what_to_share: "Chọn nội dung bạn muốn chia sẻ",
    msg_share_your_tab: "Chia sẻ tab, cửa sổ hoặc toàn bộ màn hình của bạn",
    lbl_share_pdf: "Chia sẻ PDF",
    msg_annotate_pdf: "Ghi chú, vẽ hình và nhiều tính năng khác trên PDF",
    btn_go_back: "Quay lại",
    btn_start_sharing: "Bắt đầu chia sẻ",
    lbl_start_screen_sharing: "Bắt đầu chia sẻ màn hình",
    lbl_stop_screen_sharing: "Dừng chia sẻ màn hình",
    lbl_live: "TRỰC TIẾP",

    msg_error_check_role:
      "Đã xảy ra lỗi khi kiểm tra vai trò của bạn. Vui lòng kiểm tra lại vai trò của bạn hoặc liên hệ với Seed của Circle để biết thêm chi tiết.",
    msg_room_code_is_disabled:
      "Mã phòng tương ứng với liên kết này không còn hoạt động.",
    msg_room_code_does_not_exist:
      "Chúng tôi không thể tìm thấy mã phòng tương ứng với liên kết này.",
    msg_room_does_not_exist:
      "Chúng tôi không thể tìm thấy phòng tương ứng với liên kết này.",
    msg_accessing_disabled:
      "Bạn có thể bật lại tính năng này từ phần dành cho nhà phát triển trong Trang tổng quan.",
    msg_error_fetching_token:
      "Đã xảy ra lỗi khi tìm nạp mã thông báo ứng dụng. Vui lòng xem nhật ký để biết thêm chi tiết.",
    msg_embed:
      "Nhúng url và chia sẻ với mọi người trong phòng. Đảm bảo rằng bạn đang chia sẻ tab hiện tại khi lời nhắc mở ra. Lưu ý rằng không phải tất cả các trang web đều hỗ trợ được nhúng.",

    fm_toggle_sound: "{{status}} âm thanh ({{key}} + d)",
    fm_toggle_video: "{{status}} hình ảnh ({{key}} + e)",
    fm_toggle_background: "{{status}} hình nền ảo",
    fm_gird_layout_view: "Xếp lưới trong chế độ xem({{count}})",
    fm_toggle_pip: "{{status}} chế độ ảnh trong ảnh",
    fm_interpretation_end:
      "Phiên dịch {{text1}} đã kết thúc. Bạn được chuyển về nghe {{text2}}",
    fm_interpretation_select: "Bạn đã lựa chọn nghe {{text}}",
    fm_you_have_left_cabin: "Bạn đã rời khỏi buồng dịch",
    fm_not_connect_room: "Không thể kết nối tới phòng {{name}}",
    fm_endpoint_is_not_reachable: "Không thể truy cập điểm cuối. {{desc}}",
    fm_you_out_room: "Bạn đã rời khỏi phòng {{name}}",
    fm_fullscreen: "{{action}} toàn màn hình",
    fm_open_chat: "{{action}} cửa sổ trò chuyện",
    fm_you_content: "Bạn ({{content}})",
    fm_volume: "Âm lượng ({{number}})",
    fm_pin_screen: "{{action}} khung hình",
    fm_toggle_fullscreen: "{{text}} toàn màn hình",
    fm_toggle_sharescreen: "{{text}} chia sẻ màn hình",
    fm_block_permission: "Quyền {{device}} bị chặn",
    fm_access_permission: "Cần có quyền truy cập vào {{device}}. ",
    fm_accept_permission_system: "Bật quyền cho {{device}} từ cài đặt hệ thống",
    fm_accept_permission_browser:
      "Bật quyền cho {{device}} từ thanh địa chỉ hoặc cài đặt trình duyệt",
    fm_hands_up: "{{name}} giơ tay",
    fm_hands_up_multiple: "{{name}} và {{number}} người khác giơ tay",
    fm_joined: "{{name}} đã tham gia",
    fm_left: "{{name}} đã rời đi",
    fm_left_multiple: "{{name}} và {{number}} những người khác đã rời đi",
    fm_new_message: "Tin nhắn mới từ {{name}}",
    fm_new_message_multiple: "{{number}} tin nhắn mới",
    fm_offline:
      "Bạn hiện đang trực tuyến, trong khi chúng tôi cố gắng kết nối lại, vui lòng kiểm tra kết nối internet của bạn. {{message}}",
    fm_reconnected: "Bây giờ bạn đã được kết nối",
    fm_reconnecting:
      "Bạn hiện đang ngoại tuyến. Trong khi chúng tôi cố gắng kết nối lại, vui lòng kiểm tra kết nối internet của bạn. {{message}}",
    fm_role_changed: "{{name}} hiện là {{role}}",
    fm_others_role_changed:
      "{{name}} và {{number}} người khác hiện là {{role}}",
    fm_others_joined: "{{name}} và {{number}} người khác đã tham gia",
    fm_others_left: "{{name}} và {{number}} người khác đã rời đi",
    fm_raised_hand: "{{name}} giơ tay",
    fm_others_raised_hand: "{{name}} và {{number}} người khác giơ tay",

    fm_start: "Bắt đầu",
    fm_stop: "Dừng",
    lbl_no_msg: "Không có tin nhắn",
    lbl_hands_up: "Giơ tay",
    lbl_hands_down: "Thu tay",
    lbl_open: "Mở",
    lbl_close: "Đóng",
    lbl_activate: "Bật",
    lbl_deactivate: "Tắt",
    lbl_everyone: "Mọi người",
    lbl_new_msgs: "Các tin nhắn mới",
    lbl_find_participants: "Tìm người tham gia",
    lbl_roles: "Vai trò",
    lbl_participant: "Người tham gia",
    lbl_write_smt_here: "Vui lòng nhập tin nhắn",
    lbl_toggle_all_remote_audio_devices:
      "Tắt/Bật tiếng các thiết bị âm thanh từ xa",
    lbl_all_roles: "Tất cả vai trò",
    lbl_track_type: "Loại track",
    lbl_track_source: "Nguồn track",
    lbl_track_status: "Trạng thái track",
    lbl_mute: "Tắt tiếng",
    lbl_unmute: "Yêu cầu bật tiếng",
    lbl_apply: "Áp dụng",
    lbl_all_sources: "Tất cả các nguồn",
    lbl_all_devices: "Tất cả các loại thiết bị",
    lbl_strangers: "Người lạ",
    lbl_pin_msg: "Ghim tin nhắn",
    lbl_more_options: "Tùy chọn khác",
    lbl_toggle_widget_menu: "Hiển thị/ẩn menu tiện ích",
    lbl_change_name: "Đổi tên",
    lbl_bulk_role_change: "Thay đổi vai trò hàng loạt",
    lbl_fullscreen_enter: "Vào toàn màn hình",
    lbl_fullscreen_exit: "Thoát toàn màn hình",
    lbl_show_hls_stats: "Hiển thị thống kê HLS",
    lbl_stats_for_nerds: "Thống kê chuyên sâu",
    lbl_show_stats_on_tiles: "Hiển thị thống kê trên ô",
    lbl_stats_for: "Thống kê cho",
    ph_select_stats: "Chọn thống kê",
    lbl_more: "Tùy chọn",
    lbl_copy: "Sao chép",
    lbl_copy_failed: "Sao chép thất bại",
    lbl_private: "RIÊNG TƯ",
    lbl_to: "ĐẾN",
    fm_to_peer: "ĐẾN {{peer}}",
    fm_to_you: "ĐẾN BẠN",
    lbl_no_messages_here: "Không có tin nhắn ở đây",
    lbl_embed_url: "Nhúng URL",
    lbl_url: "URL",
    lbl_embed_url_help:
      "Nhúng url và chia sẻ với mọi người trong phòng. Đảm bảo rằng bạn đang chia sẻ tab hiện tại khi lời nhắc mở ra. Lưu ý rằng không phải tất cả các trang web đều hỗ trợ được nhúng.",
    lbl_raise_hand: "Giơ tay",
    lbl_unraise_hand: "Hạ tay",
    lbl_im_back: "Tôi đã trở lại",
    lbl_ill_be_right_back: "Tôi sẽ quay lại ngay",
    lbl_spotlight_remove: "Bỏ khỏi Spotlight",
    lbl_spotlight_for_everyone: "Làm nổi bật cho mọi người",
    lbl_tile_for_myself: "Khung cho riêng tôi",

    obj_roles: {
      lbl_presenter: "Người trình bày",
      lbl_host: "Chủ tọa",
      lbl_broadcaster: "Diễn giả",
      lbl_panelist: "Tham luận viên",
      lbl_translator: "Thông dịch viên",
      "lbl_e-v": "Anh - Việt",
      "lbl_f-v": "Pháp - Việt",
      lbl_vietnamese: "Tiếng Việt",
      lbl_guest: "Khách mời",
      "lbl_guest-advanced": "Khách (Nâng cao)",
      lbl_viewer: "Người xem",
      "lbl_hls-viewer": "Người xem",
    },
    superdoc_name: "SuperDoc",
    superdoc_greeting:
      "Xin chào! Tôi là SuperDoc. Tôi luôn đồng hành cùng bác sĩ trong điều trị và chăm sóc toàn diện cho mỗi người bệnh.",
    superdoc_loading: "SuperDoc đang xử lý...",
    superdoc_empty_message: "Vui lòng nhập câu hỏi",
    signature: {
      select: "Chọn chữ ký",
      loading: "Đang tải...",
      no_signatures: "Không tìm thấy chữ ký",
      create: "Tạo chữ ký",
      provider_by: "Cung cấp bởi:",
      signed_on: "Đã ký vào:",
      status: "Trạng thái:",
      not_signed: "Chưa ký",
      warn_select_and_place:
        "Vui lòng chọn chữ ký và đặt vị trí trên tài liệu.",
      warn_select: "Vui lòng chọn chữ ký.",
      alert_title: "Thông báo",
      err_cannot_load_document: "Không thể tải tài liệu.",
      err_failed_load_signatures: "Tải chữ ký thất bại.",
      err_upload_signed_file: "Tải tài liệu đã ký thất bại.",
      err_update_envelope: "Cập nhật tài liệu sau khi ký thất bại.",
      err_intrust_wrong_pin: "Mã PIN không đúng. Vui lòng thử lại.",
      err_intrust_sign_failed: "Ký thất bại: {{message}}",
      err_already_signing: "Đang có thao tác ký đang thực hiện.",
      err_missing_secretary: "Không tìm thấy thông tin Thư ký",
      err_missing_president: "Không tìm thấy thông tin Chủ tọa",
      err_missing_treating_doctor: "Không tìm thấy thông tin Bác sĩ điều trị",
      loading_data: "Đang tải dữ liệu...",
      loading_pdf: "Đang tải PDF...",
    },
    intrust: {
      login_title: "Đăng nhập IntrustCA",
      username: "Tài khoản",
      password: "Mật khẩu",
      auth_method: "Phương thức xác thực",
      auth_pin: "PIN",
      auth_mobile: "Ứng dụng di động",
      logging_in: "Đang đăng nhập...",
      login: "Đăng nhập",
      login_missing: "Vui lòng nhập tài khoản và mật khẩu",
      login_failed: "Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin.",
      cert_title: "Chọn chứng thư IntrustCA",
      loading_certs: "Đang tải chứng thư...",
      no_certs: "Không tìm thấy chứng thư.",
      reload: "Tải lại",
      pin_label: "Mã PIN",
      pin_placeholder: "Nhập mã PIN",
      sign: "Ký",
      key_label: "Khóa",
    },

    lbl_waiting_for_the_live_stream_to_start:
      "Đang đợi buổi phát trực tiếp bắt đầu",
    lbl_live_streaming: "Đang phát trực tiếp",
    lbl_stream_management: "Quản lý phát trực tiếp",
    lbl_sign_in: "Đăng nhập",
    lbl_sign_in_desc: "Hãy đăng nhập để được vào phòng họp",
    lbl_logout: "Đăng xuất",
    lbl_anonymous: "Khách",
    lbl_email: "Email",
    lbl_password: "Mật khẩu",
    ph_email_example: "you@company.com",
    ph_password: "Mật khẩu của bạn",
    sign_in: {
      auto_failed: "Tự động đăng nhập thất bại. Vui lòng đăng nhập thủ công.",
      no_token: "Đăng nhập thất bại: không có token trả về",
      wrong_password: "Email hoặc mật khẩu không đúng. Vui lòng thử lại.",
      login_failed: "Đăng nhập thất bại",
    },
    lbl_keep_signed_in: "Giữ trạng thái đăng nhập",
    lbl_forgot_password: "Quên mật khẩu?",
    lbl_help: "Trợ giúp",
    lbl_stop_recording: "Dừng ghi video",
    lbl_are_you_sure_you_want_to_end_the_recording:
      "Bạn có chắc chắn muốn kết thúc quá trình ghi không?",
    lbl_stop: "Dừng",
    lbl_starting_recording: "Đang ghi video",
    lbl_start_recording: "Bắt đầu ghi video",
    lbl_start: "Bắt đầu",
    lbl_recording_already_running: "Bản ghi đang chạy",
    lbl_browser_message:
      'Trình duyệt yêu cầu xác nhận trước khi phát Live HODO. Vui lòng nhấp "phát luồng" để tiếp tục.',
    err_sharing_embed: "Lỗi khi chia sẻ URL nhúng {{message}}",
    lbl_auto: "Tự động",
    lbl_play: "Phát",
    lbl_pause: "Tạm dừng",
    lbl_the_conference_will_start_in: "Hội thảo sẽ bắt đầu sau",
    lbl_the_conference_will_begin_soon:
      "Hội thảo sẽ sớm được bắt đầu. \nBạn vui lòng ngồi xuống nghỉ ngơi và thư giãn trong thời gian chờ đợi.",
    lbl_the_conference_has_ended:
      "Hội thảo đã kết thúc, vui lòng quay lại vào thời điểm khác. \nXin cảm ơn!",
    lbl_you_can_connect_with_others: "Bạn không thể kết nối với người khác.",
    lbl_you_are_connected_but_no_one_is_active_in_the_circle:
      "Bạn đã kết nối nhưng chưa có người hoạt động trong vòng kết nối của bạn.",
    lbl_curentky_there_is_no_one_else_in_the_room:
      "Hiện tại, không có người nào khác trong phòng.",
    lbl_this_role_does_not_exist: "Vai trò này không tồn tại.",
    lbl_this_role_has_not_been_published: "Vai trò này chưa được công khai.",
    lbl_presentation_screen: "Màn hình thuyết trình",
    lbl_members: "Thành viên",
    lbl_agenda: "Chương trình",
    lbl_info: "Thông tin",
    lbl_role_preside: "Chủ tọa",
    lbl_role_member: "Thành viên",
    lbl_role_expert: "Chuyên gia",
    lbl_role_secretary: "Thư ký",
    lbl_mdt: "Hội chẩn",
    lbl_meetings: "Phòng họp",
    lbl_search_rooms: "Tìm phòng theo tên",
    lbl_all_meeting_rooms: "Tất cả",
    lbl_one_time_meeting_room: "Một lần",
    lbl_daily_meeting_room: "Hàng ngày",
    lbl_weekly_meeting_room: "Hàng tuần",
    fm_pagination: "Hiển thị {{countItems}} trên {{totalItems}}",
    lbl_loading: "Đang tải...",
    lbl_prev: "Lùi",
    lbl_next: "Tiếp",
    lbl_report: "Báo cáo",
    lbl_tqm: "Thông qua mổ",
    lbl_tqm_short: "TQM",
    lbl_bbhc: "BBHC",
    lbl_tttqm: "TTTQM",
    lbl_error_user_not_sign_in: "Lỗi chưa đăng nhập tài khoản",
    msg_error_user_not_sign_in:
      "Bạn vui lòng thực hiện đăng nhập và tham gia phòng họp thông qua cổng kết nối {{domain}}",
    lbl_participants_meeting: "Người tham gia",
    // lbl_save_meeting_minutes: "Lưu biên bản cuộc họp",
    // lbl_update_meeting_minutes: "Cập nhật biên bản cuộc họp",
    lbl_save_meeting_minutes: "Lưu biên bản cuộc họp",
    lbl_update_meeting_minutes: "Cập nhật biên bản cuộc họp",
    lbl_doctor: "Bác sĩ",
    lbl_patient: "Bệnh nhân",
    lbl_checked_in: "Đã điểm danh",
    lbl_not_checked_in: "Chưa điểm danh",
    presentation: {
      menu: {
        bbhc: "Biên bản hội chẩn",
        tttqm: "Tóm tắt thông qua mổ",
        documents: "Tài liệu/ xét nghiệm",
        imaging: "Chẩn đoán hình ảnh",
      },
      actions: {
        approve: "Duyệt",
        cancel_approve: "Huỷ duyệt",
        pmdt_approve: "Thông qua",
        pmdt_deny: "Không thông qua",
        pmdt_cancel: "Huỷ",
        add: "Thêm",
      },
      labels: {
        approved: "Đã duyệt",
        pmdt_approved: "Đã thông qua",
        presenter: "Người trình bày",
        unknown: "Chưa xác định",
        cases: "Số ca bệnh: {{count}}",
      },
      fields: {
        admission_date: "Ngày nhập viện:",
        diagnosis: "Chẩn đoán:",
        patient_name: "Họ tên người bệnh:",
        address: "Địa chỉ:",
        dept: "Khoa:",
        summary: "Tóm tắt bệnh án:",
        treatment_progress: "Tóm tắt diễn biến bệnh / Điều trị:",
        conclusion_note: "Kết luận (sau khi khám lại và thảo luận)",
        conclusion: "Kết luận:",
        treatment: "Hướng điều trị tiếp:",
        preside: "Chủ tọa:",
        age: "Tuổi:",
        gender: "Nam/Nữ:",
        mdt_time: "Hội chẩn lúc:",
        secretary: "Thư ký:",
        members: "Thành viên tham gia:",
        profile_code: "MHS:",
        treatment_period: "Bệnh nhân đã điều trị từ ngày nào đến ngày nào:",
        tests_section: "II. Xét nghiệm",
        test_group_blood: "1. XN máu",
        test_ure: "Ure",
        test_bilirubin_tp: "Bilirubin TP",
        test_hst: "HST",
        test_creatinin: "Creatinin",
        test_bilirubin_tt: "Bilirubin TT",
        test_hc: "HC",
        test_glucose: "Glucose",
        test_got: "GOT",
        test_hct: "HCT",
        test_blood: "Nhóm Máu",
        test_protit: "Protit",
        test_gpt: "GPT",
        test_tc: "TC",
        test_pt: "PT%",
        test_cholesterol: "Cholesterol",
        test_blood_basic: "Đông máu CB",
        test_quick: "Quick",
        test_ggt: "GGT",
        test_urine: "2. Nước tiểu",
        test_xray: "3. Xquang",
        test_electrocar: "4. Điện tim",
        test_ultrasound: "5. Siêu âm",
        test_endoscopy: "6. Nội soi",
        test_drug_reaction: "1. Thử phản ứng thuốc",
        test_antibiotics: "2. Kháng sinh trước mổ",
        test_surgery_method: "3. Phương pháp phẫu thuật",
        test_anaesthetic_method: "4. Phương pháp vô cảm",
        test_surgical_team: "5. Kíp mổ",
        test_anaesthetic_team: "6. Kíp gây mê",
        test_anatomic: "7. Giải phẫu bệnh",
        test_blood_plan: "8. Dự trù máu",
        surgery_date: "Dự kiến ngày mổ",
        prognostic: "9. Dự kiến khó khăn tiên lượng",
        signatory_chief_anes: "Trưởng khoa PT và GMHS",
        signatory_chief_surgery: "Trưởng Khoa Ngoại",
        signatory_treating_doctor: "Bác sĩ điều trị",
        select_doctor: "Chọn bác sĩ",
        preparation_section: "III. Chuẩn bị người bệnh và phương pháp điều trị",
      },
      errors: {
        approve_missing_bbhc:
          "Biên bản hội chẩn chưa được thông qua, bạn không thể duyệt ca bệnh này",
        missing_conclusion_treatment:
          "Cần có đủ Kết luận và Hướng điều trị mới lưu được Biên bản hội chẩn, vui lòng cập nhật",
        missing_operation_summary:
          "Tóm tắt thông qua mổ chưa được thông qua, bạn nên bổ sung biên bản này",
        no_bbhc: "Chưa có biên bản",
        no_tttqm: "Chưa có biên bản",
        no_document: "Không tìm thấy tài liệu",
      },
      dialogs: {
        confirm_title: "",
        confirm_body: "Bạn có chắc chắn không?",
        cancel: "Huỷ bỏ",
        confirm: "Đồng ý",
        bbhc_title: "Biên bản hội chẩn",
        tttqm_title: "Tóm tắt thông qua mổ",
        signatory_section_title: "Người kí biên bản",
        save: "Lưu",
        print: "In",
      },

      empty: "Không có dữ liệu",

      page: {
        title: "Hội chẩn",
        date_label: "Ngày:",
        participants_label: "Thành phần tham gia:",
        preside_label: "Chủ toạ:",
        approved_count: "Số lượng ca đã duyệt:",
        unapproved_count: "Số lượng ca chưa duyệt:",
      },
      toast: {
        cant_change_language: "Bạn không thể thay đổi ngôn ngữ thuyết trình.",
        changed_language:
          "Bạn đã thay đổi ngôn ngữ thuyết trình thành {{language}}.",
        no_case_selected: "Chưa chọn ca bệnh",
        no_case_data: "Không có dữ liệu ca bệnh để hỏi SuperDoc",
        superdoc_failed: "SuperDoc thất bại",
        saved_success: "Lưu thành công",
      },
      superdoc: {
        failed_message: "SuperDoc thất bại. Vui lòng thử lại sau.",
        fields: {
          summary_label: "Tóm tắt bệnh án",
          diagnosis_label: "Chẩn đoán",
          conclusion_label: "Kết luận",
          treatment_label: "Hướng điều trị tiếp",
        },
      },
      patient_info:
        "{{name}} ({{gender}} - {{age}} tuổi) - Bác sĩ phụ trách: {{doctor}}",
      case_label: "Ca {{number}}",
    },
    common: {
      success: "Thành công",
    },
  },
};

export default data;
